// store/registrationStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useRegistrationStore = create(
    persist(
        (set) => ({
            // Provider data from Step 1
            providerData: {
                providerType: '',
                facilityName: '',
                isBranch: false,
                mainBranchHANumber: '',
                healthAuthority: '',
                country: '',
                emirates: '',
                city: '',
                area: '',
                street: '',
                location: '',
                poBox: '',
                landline: '',
                website: '',
                openTime: '09:00',
                closeTime: '17:30'
            },

            // Form data from Step 2
            formData: {
                patientCapacityOP: '',
                patientCapacityIP: '',
                patientCapacityDC: '',
                discount: 0,
                tradeLicenseFile: null,
                tariffListFile: null,
                haLicenseFile: null,
                signatoryEmiratesIdFile: null,
                otherFiles: null,
            },

            // Authority data from Authority & Contact form
            authorityData: {
                facilityLicenseNo: '',
                facilityLicenseExpiry: '',
                trackLicNo: '',
                trackLicExpiry: '',
                tradeLicNo: '',
                tradeLicName: '',
                tradeLicExpiry: '',
                signatory1Name: '',
                signatory1Designation: '',
                signatory1EmiratesId: '',
                signatory1ContactNo: '',
                signatory1Remarks: '',
                networkInsuranceName1: '',
                networkInsuranceEmail1: '',
                networkInsuranceContact1: '',
                accountsName1: '',
                accountsEmail1: '',
                accountsContact1: '',
                administrationName1: '',
                administrationEmail1: '',
                administrationContact1: '',
            },

            // Services and Specialities
            selectedServices: [],
            selectedSpecialities: [],

            // Actions for Provider Data
            setProviderData: (data) => set({ providerData: data }),
            updateProviderData: (partial) =>
                set((state) => ({
                    providerData: { ...state.providerData, ...partial },
                })),

            // Actions for Form Data
            setFormData: (data) => set({ formData: data }),
            updateFormData: (partial) =>
                set((state) => ({
                    formData: { ...state.formData, ...partial },
                })),

            // Actions for Authority Data
            setAuthorityData: (data) => set({ authorityData: data }),
            updateAuthorityData: (partial) =>
                set((state) => ({
                    authorityData: { ...state.authorityData, ...partial },
                })),

            // Actions for Services
            setSelectedServices: (services) => set({ selectedServices: services }),
            toggleService: (serviceId) =>
                set((state) => {
                    const services = new Set(state.selectedServices);
                    if (services.has(serviceId)) {
                        services.delete(serviceId);
                    } else {
                        services.add(serviceId);
                    }
                    return { selectedServices: Array.from(services) };
                }),

            // Actions for Specialities
            setSelectedSpecialities: (specialities) =>
                set({ selectedSpecialities: specialities }),
            toggleSpeciality: (specialityId) =>
                set((state) => {
                    const specialities = new Set(state.selectedSpecialities);
                    if (specialities.has(specialityId)) {
                        specialities.delete(specialityId);
                    } else {
                        specialities.add(specialityId);
                    }
                    return { selectedSpecialities: Array.from(specialities) };
                }),

            // Clear all data (after submission or reset)
            clearRegistration: () =>
                set({
                    providerData: {
                        providerType: '',
                        facilityName: '',
                        isBranch: false,
                        mainBranchHANumber: '',
                        healthAuthority: '',
                        country: '',
                        emirates: '',
                        city: '',
                        area: '',
                        street: '',
                        poBox: '',
                        landline: '',
                        website: '',
                        openTime: '09:00',
                        closeTime: '18:00',
                    },
                    formData: {
                        patientCapacityOP: '',
                        patientCapacityIP: '',
                        patientCapacityDC: '',
                        tradeLicenseFile: null,
                        tariffListFile: null,
                        haLicenseFile: null,
                        signatoryEmiratesIdFile: null,
                        otherFiles: null,
                    },
                    authorityData: {
                        facilityLicenseNo: '',
                        facilityLicenseExpiry: '',
                        trackLicNo: '',
                        trackLicExpiry: '',
                        tradeLicNo: '',
                        tradeLicName: '',
                        tradeLicExpiry: '',
                        signatory1Name: '',
                        signatory1Designation: '',
                        signatory1EmiratesId: '',
                        signatory1ContactNo: '',
                        signatory1Remarks: '',
                        networkInsuranceName1: '',
                        networkInsuranceEmail1: '',
                        networkInsuranceContact1: '',
                        accountsName1: '',
                        accountsEmail1: '',
                        accountsContact1: '',
                        administrationName1: '',
                        administrationEmail1: '',
                        administrationContact1: '',
                    },
                    selectedServices: [],
                    selectedSpecialities: [],
                }),
        }),
        {
            name: 'provider-registration',
            storage: {
                getItem: (name) => {
                    const str = sessionStorage.getItem(name);
                    return str ? JSON.parse(str) : null;
                },
                setItem: (name, value) => {
                    sessionStorage.setItem(name, JSON.stringify(value));
                },
                removeItem: (name) => sessionStorage.removeItem(name),
            },
        }
    )
);

export default useRegistrationStore;